var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('div',{staticClass:"cms-partial"},[_c(_vm.htmlComponent,_vm._g(_vm._b({tag:"component",attrs:{"client-config":_vm.config}},'component',_vm.$props,false),_vm.$listeners)),(_vm.css)?_c("style",{tag:"component"},[_vm._v(_vm._s(_vm.css))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }